import Constants from 'expo-constants';
import * as IntentLauncher from 'expo-intent-launcher';
import { Linking, Platform } from 'react-native';

export async function openSettings() {
  if (Platform.OS === 'android') {
    const pkg = Constants.manifest!.android!.package;
    await IntentLauncher.startActivityAsync(
      IntentLauncher.ActivityAction.APPLICATION_DETAILS_SETTINGS,
      { data: 'package:' + pkg },
    );
  } else {
    await Linking.openURL('app-settings:');
  }
}
